/**
 * @generated SignedSource<<e13477f4d1efe81e53e34bb6fb90f675>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExternalServiceLinksContactQuery$variables = {
  contactIdentifier: string;
};
export type ExternalServiceLinksContactQuery$data = {
  readonly contactExternalLinks: ReadonlyArray<{
    readonly iconUrl: string | null | undefined;
    readonly label: string;
    readonly service: string;
    readonly url: string;
  }>;
};
export type ExternalServiceLinksContactQuery = {
  response: ExternalServiceLinksContactQuery$data;
  variables: ExternalServiceLinksContactQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contactIdentifier"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contactIdentifier",
        "variableName": "contactIdentifier"
      }
    ],
    "concreteType": "ExternalServiceLink",
    "kind": "LinkedField",
    "name": "contactExternalLinks",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "service",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalServiceLinksContactQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalServiceLinksContactQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c8608d941e131b866dc6aabefd5bb1d0",
    "id": null,
    "metadata": {},
    "name": "ExternalServiceLinksContactQuery",
    "operationKind": "query",
    "text": "query ExternalServiceLinksContactQuery(\n  $contactIdentifier: ID!\n) {\n  contactExternalLinks(contactIdentifier: $contactIdentifier) {\n    service\n    label\n    url\n    iconUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "de301ab345c1167ff9a6c9cee49613a4";

export default node;
